import { stringConstants } from '../../constants/globalConstant';

const MyTeams = () => {
  const imgURL = `/images/widgetPreview/myteams.svg`;

  return (
    <div>
      <img className="w-full" src={imgURL} alt={stringConstants.MY_TEAMS} />
    </div>
  );
};

export default MyTeams;
